module.exports = __webpack_public_path__ + "img/20191227155257195.58e105dd.jpg";